export { default } from "./use-menu-by-web-etc-flag";
